const SYSTEMS = [
  {
    icon: "ri-heart-3-line",
    title: "心动值系统",
    tone: "bg-primary-100 text-primary-700",
    text: "这是辅助器最核心的指标。每次与心仪对象互动、说出一句真诚的话，心动值都会上涨；数值越高，代表对方对你的真实好感越强烈。心动值还直接影响后续可解锁的相处模式。",
  },
  {
    icon: "ri-task-line",
    title: "限时任务",
    tone: "bg-accent-100 text-accent-700",
    text: "辅助器会不定期发布恋爱任务，例如「邀请对方一起喝杯奶茶」「说出今天最想告诉ta的一句话」。任务限时完成，成功可获得奖励，失败则扣减少量心动值。",
  },
  {
    icon: "ri-dashboard-3-line",
    title: "好感度面板",
    tone: "bg-secondary-100 text-secondary-700",
    text: "类似游戏的状态面板，清晰展示每位出场角色对自己的好感度、关系阶段与隐藏事件线索，让读者能直观看到每一段关系如何一步步升温。",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "道具商城",
    tone: "bg-primary-100 text-primary-700",
    text: "系统提供的「恋爱道具」千奇百怪，从能缓和尴尬气氛的小礼物，到用于制造偶遇的机会券。道具需用完成任务的积分兑换，如何取舍成为剧情看点。",
  },
  {
    icon: "ri-calendar-event-line",
    title: "限时事件",
    tone: "bg-accent-100 text-accent-700",
    text: "每逢节日或特殊时间点，会触发限时剧情事件。错过便无法重来，选择不同也会导向不同支线，大大增强了故事的沉浸感与可讨论性。",
  },
  {
    icon: "ri-user-heart-line",
    title: "关系羁绊",
    tone: "bg-secondary-100 text-secondary-700",
    text: "除了主角的恋爱主线，辅助器也会记录他与朋友、家人之间的羁绊值。越重视真诚的相处，羁绊带来的正向加成就越明显，凸显「用心最重要」的主题。",
  },
];

export default function System() {
  return (
    <section id="system" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-sm font-medium text-accent-700">
            <i className="ri-settings-3-line"></i>
            核心机制
          </span>
          <h2 className="mt-5 font-heading text-3xl leading-snug text-foreground-900 md:text-4xl">
            恋爱辅助器<span className="text-primary-600">系统介绍</span>
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            这台上古又时髦的「恋爱辅助器」到底能做什么？下面为你拆解它的六大核心模块，读懂这些设定，你就抓住了整部漫画的叙事引擎。
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SYSTEMS.map((s) => (
            <article
              key={s.title}
              className="group rounded-2xl border border-background-200 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1.5"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-2xl ${s.tone}`}>
                  <i className={`${s.icon} text-xl`}></i>
                </span>
                <i className="ri-arrow-right-up-line text-lg text-foreground-300 opacity-0 transition-opacity group-hover:opacity-100"></i>
              </div>
              <h3 className="mt-5 font-heading text-xl text-foreground-900">{s.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}